var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sales_box"},[(_vm.isCom)?_c('MobileAov',{attrs:{"isCom":_vm.isCom}}):_c('PcAov',{attrs:{"isCom":_vm.isCom}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }